
import Vue from 'vue'
import Loader from '@/components/Loader.vue'
import { tableFields } from '@/services'

export default Vue.extend({
  name: 'StatisticRequestsContractor',
  components: { Loader },
  data () {
    return {
      loader: false,
      fio: '',
      statisticList: [{
        name: '#0',
        request: '#1',
        address: '#2',
        cost: '#4'
      }] as any,
      fields: tableFields.STATISTIC_REQUESTS
    }
  },
  computed: {
    // idSelectedOrganization (): number {
    //   if (this.$store.state.profile.select_organization) {
    //     return this.$store.state.profile.select_organization.id
    //   }
    //   return 0
    // },
    filteredData (): any[] {
      if (this.fio) {
        return this.statisticList.filter(item => item.name.toLowerCase().includes(this.fio.toLowerCase()))
      }
      return this.statisticList
    }
  },
  watch: {
    // '$store.state.profile.select_organization' () {
    //   this.getstaticticList()
    // }
  },
  async mounted () {
    await this.getstaticticList()
  },
  methods: {
    async getstaticticList () {
      // if (!this.idSelectedOrganization) {
      //   return
      // }
    }
  }
})
